export enum RebalanceProcessStatus {
  Entry = 0,
  Process = 1,
  Waiting = 2,
  PlanExecution = 3,
  PlannedExecution = 4,
  Completed = 5,
  Declined = 6,
  /** Calculate orders created the orders; they wait in the open trade until Generate Order Book. */
  InNextTrading = 7,
}
